/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconServicemark = createReactComponent("outline", "servicemark", "IconServicemark", [["path", { "d": "M9 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-0" }], ["path", { "d": "M13 15v-6l3 4l3 -4v6", "key": "svg-1" }]]);

export { IconServicemark as default };
//# sourceMappingURL=IconServicemark.mjs.map
